/**
 * File: hero.js.
 *
 * Handles the hero navigation's visibility upon scrolling
 */

export default {
  hero: document.querySelector('.moa__hero'),
  init() {
    if (this.hero) {
      this.render();
    }
  },
  render() {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const heroBtmNav = document.querySelector('.js-hero-nav');
      const currentScroll = window.pageYOffset;

      if (((currentScroll - 80) <= this.hero.offsetHeight) && heroBtmNav) {
        heroBtmNav.classList.remove('is-visible');
        return;
      }

      if (((currentScroll - 80) >= this.hero.offsetHeight) && heroBtmNav) {
        heroBtmNav.classList.add('is-visible');
      }

      lastScroll = currentScroll;
    });
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
